module.exports = __webpack_public_path__ + "static/media/sound-from-bedroom.52633de8.mp3";